import React, { useCallback } from "react";
import { EmbedProviderProps } from "./EmbedProviders";
import { ensureScriptTag } from "./tagManager";

let galleryScriptLoading = false;
let galleryScriptLoaded = false;
const galleryPending = new Set<HTMLDivElement>();

function initIfPossible(el: HTMLDivElement | null) {
  if (!el || !el.isConnected) return;
  const setup = (window as any).setupContriblyGalleryWidget as
    | undefined
    | ((node: HTMLDivElement | string) => void);
  if (setup) {
    try {
      console.info('[ContriblyGalleryV2] Initializing element');
      setup(el);
    } catch (e) {
      console.error('[ContriblyGalleryV2] Error during vendor setup', e);
    }
  } else {
    console.info('[ContriblyGalleryV2] Vendor setup not ready yet; queueing element');
    galleryPending.add(el);
  }
}

function loadGalleryScriptOnce() {
  if (galleryScriptLoaded || galleryScriptLoading) return;
  galleryScriptLoading = true;

  const src = (window as any).contriblyGalleryScriptUrl ||
    "https://contribly-widgets.s3.eu-west-1.amazonaws.com/gallery/gallery-tickaroo.js";

  console.info('[ContriblyGalleryV2] Loading script', src);

  ensureScriptTag({
    src,
    async: true,
    onload: () => {
      galleryScriptLoaded = true;
      galleryScriptLoading = false;
      console.info('[ContriblyGalleryV2] Script loaded');
      const pendingCount = galleryPending.size;
      if (pendingCount > 0) {
        console.info('[ContriblyGalleryV2] Initializing queued elements', pendingCount);
      }
      // Initialize any queued elements that are still connected
      galleryPending.forEach((node) => initIfPossible(node));
      galleryPending.clear();
    },
    onerror: (e: any) => {
      galleryScriptLoading = false;
      console.error('[ContriblyGalleryV2] Failed to load script', src, e);
      // Optional: clear queue to avoid lingering references if load fails
      galleryPending.clear();
    },
  } as any);
}

export function ContriblyGalleryV2({ oembed }: EmbedProviderProps) {
  const ref = useCallback((el: HTMLDivElement | null) => {
    if (!el) return; // nothing to do on unmount

    // Try immediate init; if not possible, queue and ensure script loading
    initIfPossible(el);
    loadGalleryScriptOnce();
  }, []);

  return (
    <div
      className="tik4-we-contribly-gallery"
      ref={ref}
      dangerouslySetInnerHTML={{ __html: oembed.html || "" }}
    />
  );
}

export default ContriblyGalleryV2
